import { siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            <div>
              <a href="#" className="inline-block mb-4">
                <span className="text-2xl font-heading text-accent-400 font-bold">
                  黑料718
                </span>
              </a>
              <p className="text-sm leading-relaxed text-background-300">
                {siteInfo.footerDesc}
              </p>
            </div>

            <div>
              <h4 className="text-base font-heading text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                {siteInfo.footerLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-base font-heading text-background-50 mb-4">
                {siteInfo.partnersLabel}
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                合作伙伴信息将在后续更新中公布，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              {siteInfo.copyright}
            </p>
            <p className="text-xs text-background-500">
              每日更新 · 吃瓜必备 · 黑料718
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}